import React from 'react'
import {
  Content,
  StickyPositionedHeader,
  StaticPositionedHeader
} from './styles'

function getHeaderComponent(props) {
  const { fixed } = props
  let HeaderComponent

  if (fixed) {
    HeaderComponent = StickyPositionedHeader
  } else HeaderComponent = StaticPositionedHeader

  return HeaderComponent
}

export const Header = props => {
  const {
    appMinWidth,
    children,
    style,
    className,
    constrainWidth,
    disableGutter,
    left,
    right
  } = props
  const Component = getHeaderComponent(props)
  return (
    <Component appMinWidth={appMinWidth} style={style} className={className}>
      <Content
        disableGutter={disableGutter}
        constrainWidth={constrainWidth}
        left={left}
        right={right}
      >
        {children}
      </Content>
    </Component>
  )
}

Header.defaultProps = {
  fixed: false,
  isPageChild: false
}

export default Header

/**
 * Header that is child of a page should default to fixed. Only the page child should be fixed - everything
 */
